<script setup lang="ts">
import BlueLogo from "~/assets/images/TEMPLogo_BLUE.png";
import WhiteLogo from "~/assets/images/TEMPLogo_WHITE.png";
defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    size?: string;
    color?: "blue" | "white";
  }>(),
  {
    size: "w-64",
    color: "blue",
  },
);

const localePath = useLocalePath();

const logoUrl = computed(() => {
  if (props.color === "white") {
    return WhiteLogo;
  }
  return BlueLogo;
});

const logoClass = computed(() => (logoUrl.value === BlueLogo ? "py-1 blue-logo" : ""));
</script>
<template>
  <router-link :to="localePath('/')">
    <img :src="logoUrl" :alt="$t('alt.logo')" :class="[size, logoClass]" v-bind="$attrs" />
  </router-link>
</template>
